import React, { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { EnvelopeSimple, Eye } from "@phosphor-icons/react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const WeeklyTrafficEmailPanel = ({ token, email }) => {
  const [preview, setPreview] = useState(null);
  const [busy, setBusy] = useState("");
  const headers = { Authorization: `Bearer ${token}` };

  const loadPreview = () => {
    if (preview) return setPreview(null);
    setBusy("preview");
    axios.get(`${API}/analytics/weekly-report/preview`, { headers })
      .then((r) => setPreview(r.data))
      .catch(() => toast.error("Could not build the report preview"))
      .finally(() => setBusy(""));
  };

  const sendToMe = () => {
    setBusy("send");
    axios.post(`${API}/analytics/weekly-report/send`, null, { headers, params: { test_email: email } })
      .then((r) => {
        if (r.data.sent) toast.success(`Report emailed to ${email}`);
        else toast.error(r.data.error || r.data.errors?.[0] || "Email could not be sent");
      })
      .catch(() => toast.error("Email could not be sent"))
      .finally(() => setBusy(""));
  };

  return (
    <div className="bg-white border border-gray-200 p-5 mt-6" data-testid="weekly-traffic-email-panel">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <h2 className="text-lg font-serif font-bold text-[#111827] flex items-center gap-2"><EnvelopeSimple size={18} /> Weekly Traffic Email</h2>
          <p className="text-sm text-gray-500 font-sans mt-1">Every Monday morning: last week's visitors, top stories and traffic sources, straight to your inbox.</p>
        </div>
        <div className="flex gap-2">
          <button data-testid="traffic-email-preview-btn" onClick={loadPreview} disabled={!!busy} className="px-4 py-2 text-sm font-sans border border-gray-300 bg-white text-gray-700 hover:border-gray-500 disabled:opacity-50 flex items-center gap-1.5">
            <Eye size={16} /> {preview ? "Hide preview" : busy === "preview" ? "Building…" : "Preview"}
          </button>
          <button data-testid="traffic-email-send-btn" onClick={sendToMe} disabled={!!busy} className="px-4 py-2 text-sm font-sans bg-[#0F766E] text-white hover:bg-[#115E59] disabled:opacity-50">
            {busy === "send" ? "Sending…" : "Send me this week's report"}
          </button>
        </div>
      </div>
      {preview && (
        <div className="mt-4" data-testid="traffic-email-preview">
          <div className="text-xs text-gray-500 font-sans mb-2">
            Subject: <span className="text-[#111827] font-medium" data-testid="traffic-email-subject">{preview.subject}</span>
            {preview.recipients?.length > 0 && <> · Monday delivery to {preview.recipients.join(", ")}</>}
          </div>
          <iframe title="Weekly traffic report preview" srcDoc={preview.html} className="w-full h-[640px] border border-gray-200 bg-[#FFF1E5]" />
        </div>
      )}
    </div>
  );
};
